// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4cb40e99","473":"8fec4ea3","681":"1c943ac6","861":"488d8fa2"}[chunkId] + ".chunk.js";
};